export { default } from './LazyLogo';
